export default "__VITE_ASSET__BovJvJyq__"